// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --border:#ccd6e2;
  --grid:#e5edf5;
  --head:#e7f3fb;
  --bg:#f3f6fa;
  --money:#eef9e9;
  --text:#0f172a;
  --muted:#fafafa;
  --pad-cell:12px 14px;
  --pad-input:10px 12px;
  --radius:8px;
  --font:14px/1.4 ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial;
}

*{ box-sizing:border-box; }

/* Outer scroll container for iPad */
.sheet-outer-container{
  width: 100%;
  overflow: auto;
  background: var(--bg);
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  overscroll-behavior: contain;
  scroll-behavior: smooth;
  position: relative;
}

.sheet-outer-container::-webkit-scrollbar{
  width:12px;
  height:12px;
}

.sheet-outer-container::-webkit-scrollbar-track{
  background:#f1f5f9;
  border-radius:6px;
}

.sheet-outer-container::-webkit-scrollbar-thumb{
  background:#cbd5e1;
  border-radius:6px;
  border:2px solid #f1f5f9;
}

.sheet-outer-container::-webkit-scrollbar-thumb:hover{
  background:#94a3b8;
}

.sheet-outer-container::-webkit-scrollbar-corner{
  background:#f1f5f9;
}

.sheet-root{
  min-height:100vh;
  min-height:calc(var(--vh, 1vh) * 100);
  width:100%;
  display:flex;
  flex-direction:column;
  background:var(--bg);
  padding:4px;
  /* iPad specific optimizations */
  touch-action:pan-x pan-y;
  /* Ensure full width usage and all sides accessible */
  box-sizing:border-box;
  /* Allow content to extend to all edges */
  position:relative;
}

.sheet-scroll{
  flex:1 1;
  overflow:visible;              /* Let outer container handle scrolling */
  background:#fff;
  border:1px solid var(--border);
  border-radius:12px;
  margin:4px;
  box-shadow:0 6px 28px rgba(0,0,0,.06);
  /* iPad optimizations */
  touch-action:manipulation;
  position:relative;
  /* Ensure content can extend beyond container width */
  width:max-content;
  min-width:100%;
  box-sizing:border-box;
  /* No padding to allow full content visibility */
  padding:0;
  /* Allow content to scroll to all edges */
  min-height:calc(100vh - 20px);
}

/* Grid rows rendered as CSS grid so columns keep exact widths */
.sheet-row{
  display:grid;
  border-bottom:1px solid var(--grid);
  /* Ensure all sides are accessible - no padding */
  padding:0;
  /* Better touch scrolling for iPad */
  touch-action:manipulation;
  /* Allow content to extend to all edges */
  width:max-content;
  min-width:100%;
}

.sheet-head{
  position:sticky;
  top:0;
  z-index:5;
  background:var(--head);
  border-bottom:1px solid var(--border);
  /* Ensure header extends to all edges */
  width:max-content;
  min-width:100%;
}

.sheet-body .sheet-row:last-child{
  border-bottom:none;
}

/* Cells */
.cell{
  display:flex;
  align-items:center;
  padding:var(--pad-cell);
  border-right:1px solid var(--grid);
  min-height:52px;               /* Increased for better touch targets */
  background:#fff;
  /* iPad touch optimizations */
  touch-action:manipulation;
  -webkit-user-select:none;
          user-select:none;
}

.cell:last-child{ border-right:none; }

.cell.head{
  justify-content:center;
  background:var(--head);
  font-weight:700;
  color:var(--text);
  white-space:nowrap;
  min-height:56px;               /* Taller header for iPad */
  font-size:15px;                /* Slightly larger text */
}

.cell.ro{ 
  background:var(--muted);
  -webkit-user-select:text;
          user-select:text;              /* Allow text selection in read-only cells */
}

.cell.money{ 
  background:var(--money);
  font-weight:600;               /* Make money cells more prominent */
}

.in{
  width:100%;
  padding:var(--pad-input);
  border:1px solid var(--border);
  border-radius:var(--radius);
  outline:none;
  background:#fff;
  font:var(--font);
  color:var(--text);
  /* iPad input optimizations */
  font-size:16px;                /* Prevent zoom on iOS */
  appearance:none;
  touch-action:manipulation;
}

.in:focus{
  border-color:#77a8e8;
  box-shadow:0 0 0 3px rgba(119,168,232,.25);
  /* iPad focus improvements */
  transform:scale(1.02);
  transition:transform 0.1s ease;
}

.in:active{
  transform:scale(0.98);
}

.in.left{ text-align:left; }
.in.center{ text-align:center; }
.in.right{ text-align:right; }

/* Number input specific styling for iPad */
.in[type="number"]{
  appearance:textfield;
}

.in[type="number"]::-webkit-outer-spin-button,
.in[type="number"]::-webkit-inner-spin-button{
  -webkit-appearance:none;
  margin:0;
}

/* Bottom action bar */
.sheet-actions{
  padding:12px 16px 20px;
  display:flex;
  gap:12px;
  justify-content:flex-end;
  background:var(--bg);
  border-top:1px solid var(--border);
}

.btn{
  padding:14px 20px;
  border:1px solid #2563eb;
  color:#fff;
  background:#2563eb;
  border-radius:12px;
  font-weight:700;
  font-size:16px;
  cursor:pointer;
  /* iPad button optimizations */
  min-height:48px;               /* Minimum touch target size */
  min-width:120px;
  touch-action:manipulation;
  -webkit-tap-highlight-color:transparent;
  transition:all 0.2s ease;
}

.btn:hover{ 
  filter:brightness(0.95);
  transform:translateY(-1px);
}

.btn:active{
  transform:translateY(0);
  filter:brightness(0.9);
}

/* iPad specific media queries */
@media screen and (max-width: 1024px) and (orientation: landscape) {
  .sheet-outer-container{
    padding:0;
    margin:0;
    /* Enhanced iPad scroll for all sides */
    -webkit-overflow-scrolling:touch;
    overscroll-behavior:contain;
  }
  
  .sheet-root{
    padding:2px;
  }
  
  .sheet-scroll{
    padding:0;
    /* Ensure all content is accessible including right side */
    width:max-content;
    min-height:calc(100vh - 10px);
  }
  
  .cell{
    min-height:48px;
    padding:10px 12px;
  }
  
  .cell.head{
    min-height:52px;
    font-size:14px;
  }
  
  .sheet-actions{
    padding:8px 12px 12px;
  }
}

@media screen and (max-width: 1024px) and (orientation: portrait) {
  .sheet-outer-container{
    padding:0;
    margin:0;
    /* Enhanced iPad scroll for all sides */
    -webkit-overflow-scrolling:touch;
    overscroll-behavior:contain;
  }
  
  .sheet-root{
    padding:4px;
  }
  
  .sheet-scroll{
    padding:0;
    /* Ensure all content is accessible including right side */
    width:max-content;
    min-height:calc(100vh - 20px);
  }
  
  .sheet-actions{
    padding:16px 20px 24px;
  }
  
  .btn{
    padding:16px 24px;
    font-size:18px;
    min-height:56px;
  }
  
  .cell{
    min-height:56px;
    padding:12px 14px;
  }
  
  .cell.head{
    min-height:60px;
    font-size:16px;
  }
}

/* iPad Pro specific optimizations */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  .sheet-outer-container{
    padding:0;
    margin:0;
    /* Enhanced iPad Pro scroll for all sides */
    -webkit-overflow-scrolling:touch;
    overscroll-behavior:contain;
  }
  
  .sheet-root{
    padding:6px;
  }
  
  .sheet-scroll{
    margin:6px;
    padding:0;
    /* Ensure all content is accessible including right side */
    width:max-content;
    min-height:calc(100vh - 30px);
  }
}

/* Touch device optimizations */
@media (hover: none) and (pointer: coarse) {
  .sheet-outer-container{
    -webkit-overflow-scrolling:touch;
    overscroll-behavior:contain;
    /* Better momentum scrolling */
    scroll-behavior:smooth;
  }
  
  .sheet-scroll{
    /* Ensure content is fully scrollable */
    overflow:visible;
    touch-action:pan-x pan-y;
  }
  
  .sheet-row{
    /* Better touch interaction */
    touch-action:manipulation;
  }
  
  .cell{
    min-height:56px;
    /* Better touch targets */
    touch-action:manipulation;
  }
  
  .btn{
    min-height:56px;
    min-width:140px;
    /* Better touch feedback */
    touch-action:manipulation;
  }
  
  .in{
    font-size:16px;
    padding:12px 14px;
    /* Prevent zoom on focus */
    touch-action:manipulation;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/labor-sheet/LaborSheet.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,6FAA6F;AAC/F;;AAEA,GAAG,qBAAqB,EAAE;;AAE1B,oCAAoC;AACpC;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,iCAAiC;EACjC,qBAAqB;EACrB,gCAAgC;EAChC,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,gCAAgC;EAChC,wBAAwB;EACxB,qDAAqD;EACrD,qBAAqB;EACrB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,QAAM;EACN,gBAAgB,eAAe,yCAAyC;EACxE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,qDAAqD;EACrD,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gDAAgD;EAChD,SAAS;EACT,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA,gEAAgE;AAChE;EACE,YAAY;EACZ,mCAAmC;EACnC,iDAAiD;EACjD,SAAS;EACT,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;EACzC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,KAAK;EACL,SAAS;EACT,sBAAsB;EACtB,qCAAqC;EACrC,uCAAuC;EACvC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe,gBAAgB,uCAAuC;EACtE,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA,kBAAkB,iBAAiB,EAAE;;AAErC;EACE,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe,gBAAgB,2BAA2B;EAC1D,cAAc,iBAAiB,yBAAyB;AAC1D;;AAEA;EACE,uBAAuB;EACvB,wBAAgB;UAAhB,gBAAgB,eAAe,4CAA4C;AAC7E;;AAEA;EACE,uBAAuB;EACvB,eAAe,gBAAgB,oCAAoC;AACrE;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc,iBAAiB,wBAAwB;EAEvD,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,4BAA4B;EAC5B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,UAAU,eAAe,EAAE;AAC3B,YAAY,iBAAiB,EAAE;AAC/B,WAAW,gBAAgB,EAAE;;AAE7B,2CAA2C;AAC3C;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,uBAAuB;EACvB,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,wBAAwB;EACxB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,eAAe,gBAAgB,8BAA8B;EAC7D,eAAe;EACf,yBAAyB;EACzB,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE;IACE,SAAS;IACT,QAAQ;IACR,uCAAuC;IACvC,gCAAgC;IAChC,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,0DAA0D;IAC1D,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,SAAS;IACT,QAAQ;IACR,uCAAuC;IACvC,gCAAgC;IAChC,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,0DAA0D;IAC1D,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,SAAS;IACT,QAAQ;IACR,2CAA2C;IAC3C,gCAAgC;IAChC,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,SAAS;IACT,0DAA0D;IAC1D,iBAAiB;IACjB,6BAA6B;EAC/B;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,gCAAgC;IAChC,2BAA2B;IAC3B,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,uCAAuC;IACvC,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,yBAAyB;EAC3B;AACF","sourcesContent":[":root{\n  --border:#ccd6e2;\n  --grid:#e5edf5;\n  --head:#e7f3fb;\n  --bg:#f3f6fa;\n  --money:#eef9e9;\n  --text:#0f172a;\n  --muted:#fafafa;\n  --pad-cell:12px 14px;\n  --pad-input:10px 12px;\n  --radius:8px;\n  --font:14px/1.4 ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto, Helvetica, Arial;\n}\n\n*{ box-sizing:border-box; }\n\n/* Outer scroll container for iPad */\n.sheet-outer-container{\n  width: 100%;\n  overflow: auto;\n  background: var(--bg);\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 #f1f5f9;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  overscroll-behavior: contain;\n  scroll-behavior: smooth;\n  position: relative;\n}\n\n.sheet-outer-container::-webkit-scrollbar{\n  width:12px;\n  height:12px;\n}\n\n.sheet-outer-container::-webkit-scrollbar-track{\n  background:#f1f5f9;\n  border-radius:6px;\n}\n\n.sheet-outer-container::-webkit-scrollbar-thumb{\n  background:#cbd5e1;\n  border-radius:6px;\n  border:2px solid #f1f5f9;\n}\n\n.sheet-outer-container::-webkit-scrollbar-thumb:hover{\n  background:#94a3b8;\n}\n\n.sheet-outer-container::-webkit-scrollbar-corner{\n  background:#f1f5f9;\n}\n\n.sheet-root{\n  min-height:100vh;\n  min-height:calc(var(--vh, 1vh) * 100);\n  width:100%;\n  display:flex;\n  flex-direction:column;\n  background:var(--bg);\n  padding:4px;\n  /* iPad specific optimizations */\n  touch-action:pan-x pan-y;\n  /* Ensure full width usage and all sides accessible */\n  box-sizing:border-box;\n  /* Allow content to extend to all edges */\n  position:relative;\n}\n\n.sheet-scroll{\n  flex:1;\n  overflow:visible;              /* Let outer container handle scrolling */\n  background:#fff;\n  border:1px solid var(--border);\n  border-radius:12px;\n  margin:4px;\n  box-shadow:0 6px 28px rgba(0,0,0,.06);\n  /* iPad optimizations */\n  touch-action:manipulation;\n  position:relative;\n  /* Ensure content can extend beyond container width */\n  width:max-content;\n  min-width:100%;\n  box-sizing:border-box;\n  /* No padding to allow full content visibility */\n  padding:0;\n  /* Allow content to scroll to all edges */\n  min-height:calc(100vh - 20px);\n}\n\n/* Grid rows rendered as CSS grid so columns keep exact widths */\n.sheet-row{\n  display:grid;\n  border-bottom:1px solid var(--grid);\n  /* Ensure all sides are accessible - no padding */\n  padding:0;\n  /* Better touch scrolling for iPad */\n  touch-action:manipulation;\n  /* Allow content to extend to all edges */\n  width:max-content;\n  min-width:100%;\n}\n\n.sheet-head{\n  position:sticky;\n  top:0;\n  z-index:5;\n  background:var(--head);\n  border-bottom:1px solid var(--border);\n  /* Ensure header extends to all edges */\n  width:max-content;\n  min-width:100%;\n}\n\n.sheet-body .sheet-row:last-child{\n  border-bottom:none;\n}\n\n/* Cells */\n.cell{\n  display:flex;\n  align-items:center;\n  padding:var(--pad-cell);\n  border-right:1px solid var(--grid);\n  min-height:52px;               /* Increased for better touch targets */\n  background:#fff;\n  /* iPad touch optimizations */\n  touch-action:manipulation;\n  user-select:none;\n}\n\n.cell:last-child{ border-right:none; }\n\n.cell.head{\n  justify-content:center;\n  background:var(--head);\n  font-weight:700;\n  color:var(--text);\n  white-space:nowrap;\n  min-height:56px;               /* Taller header for iPad */\n  font-size:15px;                /* Slightly larger text */\n}\n\n.cell.ro{ \n  background:var(--muted);\n  user-select:text;              /* Allow text selection in read-only cells */\n}\n\n.cell.money{ \n  background:var(--money);\n  font-weight:600;               /* Make money cells more prominent */\n}\n\n.in{\n  width:100%;\n  padding:var(--pad-input);\n  border:1px solid var(--border);\n  border-radius:var(--radius);\n  outline:none;\n  background:#fff;\n  font:var(--font);\n  color:var(--text);\n  /* iPad input optimizations */\n  font-size:16px;                /* Prevent zoom on iOS */\n  -webkit-appearance:none;\n  appearance:none;\n  touch-action:manipulation;\n}\n\n.in:focus{\n  border-color:#77a8e8;\n  box-shadow:0 0 0 3px rgba(119,168,232,.25);\n  /* iPad focus improvements */\n  transform:scale(1.02);\n  transition:transform 0.1s ease;\n}\n\n.in:active{\n  transform:scale(0.98);\n}\n\n.in.left{ text-align:left; }\n.in.center{ text-align:center; }\n.in.right{ text-align:right; }\n\n/* Number input specific styling for iPad */\n.in[type=\"number\"]{\n  -moz-appearance:textfield;\n  appearance:textfield;\n}\n\n.in[type=\"number\"]::-webkit-outer-spin-button,\n.in[type=\"number\"]::-webkit-inner-spin-button{\n  -webkit-appearance:none;\n  margin:0;\n}\n\n/* Bottom action bar */\n.sheet-actions{\n  padding:12px 16px 20px;\n  display:flex;\n  gap:12px;\n  justify-content:flex-end;\n  background:var(--bg);\n  border-top:1px solid var(--border);\n}\n\n.btn{\n  padding:14px 20px;\n  border:1px solid #2563eb;\n  color:#fff;\n  background:#2563eb;\n  border-radius:12px;\n  font-weight:700;\n  font-size:16px;\n  cursor:pointer;\n  /* iPad button optimizations */\n  min-height:48px;               /* Minimum touch target size */\n  min-width:120px;\n  touch-action:manipulation;\n  -webkit-tap-highlight-color:transparent;\n  transition:all 0.2s ease;\n}\n\n.btn:hover{ \n  filter:brightness(0.95);\n  transform:translateY(-1px);\n}\n\n.btn:active{\n  transform:translateY(0);\n  filter:brightness(0.9);\n}\n\n/* iPad specific media queries */\n@media screen and (max-width: 1024px) and (orientation: landscape) {\n  .sheet-outer-container{\n    padding:0;\n    margin:0;\n    /* Enhanced iPad scroll for all sides */\n    -webkit-overflow-scrolling:touch;\n    overscroll-behavior:contain;\n  }\n  \n  .sheet-root{\n    padding:2px;\n  }\n  \n  .sheet-scroll{\n    padding:0;\n    /* Ensure all content is accessible including right side */\n    width:max-content;\n    min-height:calc(100vh - 10px);\n  }\n  \n  .cell{\n    min-height:48px;\n    padding:10px 12px;\n  }\n  \n  .cell.head{\n    min-height:52px;\n    font-size:14px;\n  }\n  \n  .sheet-actions{\n    padding:8px 12px 12px;\n  }\n}\n\n@media screen and (max-width: 1024px) and (orientation: portrait) {\n  .sheet-outer-container{\n    padding:0;\n    margin:0;\n    /* Enhanced iPad scroll for all sides */\n    -webkit-overflow-scrolling:touch;\n    overscroll-behavior:contain;\n  }\n  \n  .sheet-root{\n    padding:4px;\n  }\n  \n  .sheet-scroll{\n    padding:0;\n    /* Ensure all content is accessible including right side */\n    width:max-content;\n    min-height:calc(100vh - 20px);\n  }\n  \n  .sheet-actions{\n    padding:16px 20px 24px;\n  }\n  \n  .btn{\n    padding:16px 24px;\n    font-size:18px;\n    min-height:56px;\n  }\n  \n  .cell{\n    min-height:56px;\n    padding:12px 14px;\n  }\n  \n  .cell.head{\n    min-height:60px;\n    font-size:16px;\n  }\n}\n\n/* iPad Pro specific optimizations */\n@media screen and (min-width: 1024px) and (max-width: 1366px) {\n  .sheet-outer-container{\n    padding:0;\n    margin:0;\n    /* Enhanced iPad Pro scroll for all sides */\n    -webkit-overflow-scrolling:touch;\n    overscroll-behavior:contain;\n  }\n  \n  .sheet-root{\n    padding:6px;\n  }\n  \n  .sheet-scroll{\n    margin:6px;\n    padding:0;\n    /* Ensure all content is accessible including right side */\n    width:max-content;\n    min-height:calc(100vh - 30px);\n  }\n}\n\n/* Touch device optimizations */\n@media (hover: none) and (pointer: coarse) {\n  .sheet-outer-container{\n    -webkit-overflow-scrolling:touch;\n    overscroll-behavior:contain;\n    /* Better momentum scrolling */\n    scroll-behavior:smooth;\n  }\n  \n  .sheet-scroll{\n    /* Ensure content is fully scrollable */\n    overflow:visible;\n    touch-action:pan-x pan-y;\n  }\n  \n  .sheet-row{\n    /* Better touch interaction */\n    touch-action:manipulation;\n  }\n  \n  .cell{\n    min-height:56px;\n    /* Better touch targets */\n    touch-action:manipulation;\n  }\n  \n  .btn{\n    min-height:56px;\n    min-width:140px;\n    /* Better touch feedback */\n    touch-action:manipulation;\n  }\n  \n  .in{\n    font-size:16px;\n    padding:12px 14px;\n    /* Prevent zoom on focus */\n    touch-action:manipulation;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
